import React, { useEffect, useState } from "react";
import DataTable from "react-data-table-component";
import DataTableExtensions from "react-data-table-component-extensions";
import axios from "axios";
import {  Link, useNavigate } from 'react-router-dom'
import banner from '../../../images/banners/login.jpg'
import loading from '../../../images/spin.gif'
import { useSearchParams } from 'react-router-dom';
import "react-data-table-component-extensions/dist/index.css";

const SERVER_URL = process.env.REACT_APP_SERVER_URL;
export default function Wallet_user_topin() {

    //const url=window.location.href
    //const user_id = url.split("/").pop();
   //const [userid, setawb] = useState(user_id);

  const adminno = sessionStorage.getItem('adminno')
  const navigate=useNavigate()
  if(adminno == 0 || adminno == '' || !adminno){
    navigate('/wallet-dashboard/signin/')
  }

  //console.log(adminno)
  
function walletDashboard_logout(){
  sessionStorage.removeItem('adminno')
 // alert("user logged out successfully");//
  navigate('/wallet-dashboard/signin/')
}

   
    let params = new URLSearchParams(document.location.search);
    let action_type = params.get("type"); 
    let user_id = params.get("code"); 

    
   const [userid, setawb] = useState(user_id);
   const [action, setAction] = useState(action_type);

  const API_PATH = `${SERVER_URL}wallet-users-transaction.php`; 
  //const API_PATH = "http://localhost:8000/user_transactions.php"; 
  const [orders, setorders] = useState('')
  const [ordercount, setordercount] = useState(0)
  const [data, setdata2] = useState([])
  const [isload, setisload] = useState(true)
  useEffect(() => {

      axios({
        method: 'post',
        url: `${API_PATH}`,
        data:{userid:userid, action:action}
      })
        .then((res) => {
            //console.log(res.data);
          setisload(false)
         
          setordercount(res.data.length)
      
          setdata2(res.data)
       setorders(JSON.parse(JSON.stringify(res.data)))
       
        }
        )
        .catch((err) => console.log(err))
  
    }, [])
  
  const columns = [
     
      {
        name: "No.",
        selector: "row_num",
        sortable: true   
      },
      {
        name: "paymentID",
        selector: "paymentID",
        sortable: true    
      },
      {
          name: "user_id",
          selector: "user_id",
          sortable: true
        }
      ,
      {
          name: "display_name",
          selector: "display_name",
          sortable: true
        }
        ,
      {
          name: "user_email",
          selector: "user_email",
          sortable: true
        }
        ,
      {
          name: "amount",
          selector: "amount",
          sortable: true
        }
        ,
      {
        name: "bonus_credit",
        selector: "bonus_credit",
        sortable: true
      }
        ,
      {
        name: "total_topin",
        selector: "total_topin",
        sortable: true
      },
      {
        name: "date_on",
        selector: "date_on",
        sortable: true
      }
    ];
    const tableData = {
      columns,
      data
    };


  
 
  return (
    <div>
       <section className="your_business_page fw" style={{ backgroundImage:  `url(${banner})`, backgroundAttachment: 'fixed', backgroundSize: 'cover' }}>
              <div className="container"><div className="row">
                    <div className="col-md-12 col-sm-12 your_business text-center">
                        <div className="business_content">
                            <h2>Wallet Transactions Top In</h2>
                            <p><a className="" style={{cursor: "pointer", textDecoration: "underline"}} onClick={walletDashboard_logout}>- Logout -</a></p>
                           
                        </div>
                    </div>
                </div>
                </div>
            </section>
        <div className="pages_content">
            <div className="container">
            <div className="row">
            <div id="primary" className="content-area" style={{float: 'left', width: '100%'}}>
            <main id="main" className="site-main" role="main">
           <div className="entry-content">
           <div className="become_driver">
           {isload?(
  <div style={{textAlign:"center"}}>
  <p style={{textAlign:"center"}}>Please wait. The data is loading ! </p>
  <img src={loading} alt="" style={{width:"4%"}}  />
  </div>
):(<DataTableExtensions {...tableData}>
  <DataTable
    columns={columns}
    data={data}
    noHeader
    defaultSortField="id"
    // sortIcon={<SortIcon />}
    defaultSortAsc={true}
    pagination
    highlightOnHover
    dense
  />
</DataTableExtensions>
)}
             </div>


            </div>
            </main>
            </div>
            </div>
            </div>
            </div>
    </div>
  )
}
